import Stack from "@mui/material/Stack";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import Box from "@mui/material/Box";
import HomeIcon from "@mui/icons-material/Home";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ROUTE_BROWSE_JOBS_NEW, ROUTE_MAIN, ROUTE_COMPLETE_PROFILE } from "../../constants/routes";
import { AccountCircle } from "@mui/icons-material";
import { logoutClear } from "../../redux/actions/appActions";
import CandidateDeleteAccount from "../profile/CandidateDeleteAccount";

const MobileSettings = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.app.user);
  const { fullName, profileImage, phoneNumber } = user?.user || {};

  const handleLogout = () => {
    dispatch(logoutClear(()=>{
        navigate(ROUTE_MAIN, { replace: true });
    }));
    // localStorage.clear();
    // navigate(ROUTE_SIGNIN_NEW);
  };

  return (
    <>
      <section style={{ backgroundColor: "#F5F6FA" }}>
        <Stack direction="row" alignItems="center" style={{ backgroundColor: "#FFFFFF" }} className="py-3">
          <KeyboardArrowLeftIcon style={{ fontSize: "22px", fontWeight: "bold" }} className="mt-1" />
          <span style={{ fontSize: "16px", fontWeight: "600" }}>Back</span>
        </Stack>

        <Box style={{ backgroundColor: "#FF8960" }} className="py-4 position-relative">
          <Stack direction="row" alignItems="center" className="ms-3">
            <HomeIcon className="text-white me-2" /> <h4 className="text-white"> Home</h4>
          </Stack>

          <Container
            maxWidth="sm"
            className="position-absolute"
            style={{ top: "40%", borderRadius: "30px", boxShadow: "0px -4px 10px 0px #CDCDCD40" }}
          >
            <Card style={{ borderRadius: "15px", boxShadow: "0px 7px 10px 0px #CDCDCD40" }}>
              <CardContent>
                <Stack direction="row" alignItems="center">
                  <Avatar alt="EMPLOYER_USER" src={profileImage} sx={{ width: 56, height: 56 }}>
                    <AccountCircle />
                  </Avatar>

                  <div className="ms-2">
                    <h3 style={{ fontSize: "18.91px" }} className="text-dark">
                      {fullName}
                    </h3>
                  </div>
                </Stack>

                <Divider variant="fullWidth" className="mt-3" />

                <p style={{ color: "#000000", fontSize: "14px" }} className="mb-4 mt-4">
                  QUICK ACTIONS
                </p>
                <Stack direction="row" className="mb-4" onClick={() => navigate(ROUTE_COMPLETE_PROFILE)}>
                  <img className="me-3" src="/images/nav/job-activities.png" alt="" style={{ objectFit: "contain" }} />
                  <p style={{ color: "#263238", fontSize: "16px" }}>Job Activities</p>
                </Stack>
                <Stack direction="row" className="mb-4" onClick={() => navigate(ROUTE_BROWSE_JOBS_NEW)}>
                  <img
                    className="me-3"
                    src="/images/nav/browse-job-opening.png"
                    alt=""
                    style={{ objectFit: "contain" }}
                  />
                  <p style={{ color: "#263238", fontSize: "16px" }}>Browse Job Opening</p>
                </Stack>
                {/* <Stack direction="row" className="mb-4">
                  <img
                    className="me-3"
                    src="/images/nav/my-catalyst-video-cv.png"
                    alt=""
                    style={{ objectFit: "contain" }}
                  />
                  <p style={{ color: "#263238", fontSize: "16px" }}>My Catalyst Video CV</p>
                </Stack> */}
                {/* <Stack direction="row" className="mb-4">
                  <img className="me-3" src="/images/nav/interview-prep.png" alt="" style={{ objectFit: "contain" }} />
                  <p style={{ color: "#263238", fontSize: "16px" }}>Interview Prep</p>
                </Stack>
                <Stack direction="row" className="mb-4">
                  <img className="me-3" src="/images/settings.png" alt="" style={{ objectFit: "contain" }} />
                  <p style={{ color: "#263238", fontSize: "16px" }}>Settings</p>
                </Stack> */}
              </CardContent>
            </Card>
          </Container>
        </Box>

        <Container maxWidth="sm">
          <div className="position-absolute" style={{ marginTop: "60%", padding: "16px" }}>
            <p style={{ color: "#000000", fontSize: "14px" }} className="mb-4 mt-4">
              QUICK ACTIONS
            </p>
            <Stack direction="row" className="mb-4" onClick={() => navigate(ROUTE_COMPLETE_PROFILE)}>
              <img className="me-3" src="/images/settings-1.png" alt="" style={{ objectFit: "contain" }} />
              <p style={{ color: "#263238", fontSize: "16px" }}>Edit Profile</p>
            </Stack>
            {/* <Stack direction="row" className="mb-4">
              <img className="me-3" src="/images/settings-2.png" alt="" style={{ objectFit: "contain" }} />
              <p style={{ color: "#263238", fontSize: "16px" }}>Browsing History</p>
            </Stack>
            <Stack direction="row" className="mb-4">
              <img className="me-3" src="/images/settings-3.png" alt="" style={{ objectFit: "contain" }} />
              <p style={{ color: "#263238", fontSize: "16px" }}>Calendar</p>
            </Stack>
            <Stack direction="row" className="mb-4">
              <img className="me-3" src="/images/settings-4.png" alt="" style={{ objectFit: "contain" }} />
              <p style={{ color: "#263238", fontSize: "16px" }}>My Chats</p>
            </Stack> */}

            <Box sx={{ marginBottom: "100px" }}>
              <p style={{ color: "#000000", fontSize: "14px" }} className="mt-3 mb-2">
                More
              </p>
              {/* <Stack direction="row" className="mb-4">
                <img className="me-3" src="/images/settings-5.png" alt="" style={{ objectFit: "contain" }} />
                <p style={{ color: "#263238", fontSize: "16px" }}>Share App</p>
              </Stack>
              <Stack direction="row" className="mb-4">
                <img className="me-3" src="/images/settings-5.png" alt="" style={{ objectFit: "contain" }} />
                <p style={{ color: "#263238", fontSize: "16px" }}>Help / How the App works</p>
              </Stack> */}
              <Stack direction="row" className="mb-4" onClick={handleLogout}>
                <img className="me-3" src="/images/settings-6.png" alt="" style={{ objectFit: "contain" }} />
                <p style={{ color: "#263238", fontSize: "16px" }}>Logout</p>
              </Stack>
              <Box sx={{ pl: 0.5 }}>
                <CandidateDeleteAccount phoneNumber={phoneNumber} />
              </Box>
            </Box>
          </div>
        </Container>
      </section>
    </>
  );
};

export default MobileSettings;
